<template>
    <div class="fivefu">
        <Head :index="'5'"></Head>
        <div class="fl">
            本人姓名：
            <el-input type="text" v-model="name" autocomplete="off"></el-input>
            父亲姓名：
            <el-input type="text" v-model="fathername" autocomplete="off"></el-input>
            <el-button @click="search()" type="primary" size="small" style="margin-left:107px">查看</el-button>
        </div>

        <el-tabs v-model="activeName" ><!-- @tab-click="handleClick" -->
            <el-tab-pane label="九族五服表" name="table" class="table ">
                <table class="el-table" style="width:520px;max-height:100%;">
                <thead class="has-gutter">
                    <tr class="">
                        <th class="is-center is-leaf el-table__cell" style="width:110px"><div class="cell">血缘关系</div></th>
                        <th class="is-center is-leaf el-table__cell" style="width:200px"><div class="cell">称谓</div></th>
                        <th class="is-center is-leaf el-table__cell" style="width:120px"><div class="cell">姓名</div></th>
                        <th class="is-center is-leaf el-table__cell" style="width:110px"><div class="cell">在世情况</div></th>
                    </tr>
                </thead>
                <tbody>
                    <!--  -->
                    <tr v-if="tableData.length == 0">
                        <td colspan="5" style="text-align:center">暂无数据</td>
                    </tr>
                    <tr class="el-table__row backColor1" v-for="(item, index) in data.oneFuZiJi" :key="index">
                        <td v-if="index == 0" :rowspan="data.oneFuZiJi.length">
                            <div class="cell">一服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.oneFuZiJi.length">
                            <div class="cell">自己</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor1" v-for="(item, index) in data.oneFuFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.oneFuFuMu.length">
                            <div class="cell">一服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.oneFuFuMu.length">
                            <div class="cell">父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor1" v-for="(item, index) in data.oneFuZiNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.oneFuZiNv.length">
                            <div class="cell">一服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.oneFuZiNv.length">
                            <div class="cell">子女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>


                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuZuFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuZuFuMu.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuZuFuMu.length">
                            <div class="cell">祖父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuXiongDi" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuXiongDi.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuXiongDi.length">
                            <div class="cell">兄弟</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuJieMei" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuJieMei.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuJieMei.length">
                            <div class="cell">姐妹</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuShuBo" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuShuBo.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuShuBo.length">
                            <div class="cell">叔伯</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuGuGu" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuGuGu.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuGuGu.length">
                            <div class="cell">姑姑</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuZhiZi" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuZhiZi.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuZhiZi.length">
                            <div class="cell">侄子</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuZhiNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuZhiNv.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuZhiNv.length">
                            <div class="cell">侄女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor2" v-for="(item, index) in data.twoFuSunZiNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.twoFuSunZiNv.length">
                            <div class="cell">二服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.twoFuSunZiNv.length">
                            <div class="cell">孙子孙女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>


                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuZengZuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuZengZuMu.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuZengZuMu.length">
                            <div class="cell">曾祖、祖母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuZengSunNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuZengSunNv.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuZengSunNv.length">
                            <div class="cell">曾孙、孙女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoZuFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoZuFuMu.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoZuFuMu.length">
                            <div class="cell">叔伯祖父、叔伯祖母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuZuGu" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuZuGu.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuZuGu.length">
                            <div class="cell">祖姑</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoSun" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoSun.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoSun.length">
                            <div class="cell">叔伯孙子</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoSunNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoSunNv.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoSunNv.length">
                            <div class="cell">叔伯孙女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoFuMu.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoFuMu.length">
                            <div class="cell">叔伯父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoGu" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoGu.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoGu.length">
                            <div class="cell">叔伯姑姑</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoZhiZi" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoZhiZi.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoZhiZi.length">
                            <div class="cell">叔伯侄子</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoZhiNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoZhiNv.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoZhiNv.length">
                            <div class="cell">叔伯侄女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoXiongDi" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoXiongDi.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoXiongDi.length">
                            <div class="cell">叔伯兄弟</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoJieMei" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoJieMei.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoJieMei.length">
                            <div class="cell">叔伯姐妹</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor3" v-for="(item, index) in data.threeFuShuBoBoFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoBoFuMu.length">
                            <div class="cell">三服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.threeFuShuBoBoFuMu.length">
                            <div class="cell">叔伯伯</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>


                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangZuFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangZuFuMu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangZuFuMu.length">
                            <div class="cell">堂祖父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangZuGu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangZuGu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangZuGu.length">
                            <div class="cell">堂祖姑</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangSunZi" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangSunZi.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangSunZi.length">
                            <div class="cell">堂孙子</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangSunNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangSunNv.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangSunNv.length">
                            <div class="cell">堂孙女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuGaoZuFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuGaoZuFuMu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuGaoZuFuMu.length">
                            <div class="cell">高祖父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuXuanSunNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuXuanSunNv.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuXuanSunNv.length">
                            <div class="cell">玄孙玄孙女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuShuBoZengZuFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuShuBoZengZuFuMu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuShuBoZengZuFuMu.length">
                            <div class="cell">叔伯曾祖父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuZengZuGu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuZengZuGu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuZengZuGu.length">
                            <div class="cell">曾祖姑</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuShuBoZengSun" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuShuBoZengSun.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuShuBoZengSun.length">
                            <div class="cell">叔伯曾孙</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuBoShuZengSunNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuBoShuZengSunNv.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuBoShuZengSunNv.length">
                            <div class="cell">叔伯曾孙女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangBoFuMu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangBoFuMu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangBoFuMu.length">
                            <div class="cell">堂伯父母</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangGu" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangGu.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangGu.length">
                            <div class="cell">堂姑</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangZhi" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangZhi.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangZhi.length">
                            <div class="cell">堂侄子</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangZhiNv" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangZhiNv.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangZhiNv.length">
                            <div class="cell">堂侄女</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangXiongDi" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangXiongDi.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangXiongDi.length">
                            <div class="cell">堂兄弟</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor4" v-for="(item, index) in data.fourFuTangJieMei" :key="index">
                        <td v-if="index == 0" :rowspan="data.fourFuTangJieMei.length">
                            <div class="cell">四服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fourFuTangJieMei.length">
                            <div class="cell">堂姐妹</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor5" v-for="(item, index) in data.fiveFuCongXiongDi" :key="index">
                        <td v-if="index == 0" :rowspan="data.fiveFuCongXiongDi.length">
                            <div class="cell">五服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fiveFuCongXiongDi.length">
                            <div class="cell">从兄弟</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                    <tr class="el-table__row backColor5" v-for="(item, index) in data.fiveFuCongJieMei" :key="index">
                        <td v-if="index == 0" :rowspan="data.fiveFuCongJieMei.length">
                            <div class="cell">五服</div>
                        </td>
                        <td v-if="index == 0" :rowspan="data.fiveFuCongJieMei.length">
                            <div class="cell">从姐妹</div>
                        </td>
                        <td>
                            <div class="cell">{{ item.xm }}</div>
                        </td>
                        <td style="text-align:center">
                            <div class="cell">{{ item.sgzt == 1 ? "已故":"在世"  }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </el-tab-pane>
            <el-tab-pane label="九族五服图" name="map" class="mapdiv ">
                <ul>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuGaoZuFuMu.length == 1 ?'oneway':(data.fourFuGaoZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuGaoZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuShuBoZengZuFuMu.length == 1 ?'oneway':(data.fourFuShuBoZengZuFuMu.length > 6 ? 'spanmore':'')"  v-for="(item, index) in data.fourFuShuBoZengZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuZengZuMu.length == 1 ?'oneway':(data.threeFuZengZuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuZengZuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuZengZuGu.length == 1 ?'oneway':(data.fourFuZengZuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuZengZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZuFuMu.length == 1 ?'oneway':(data.fourFuTangZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoZuFuMu.length == 1 ?'oneway':(data.threeFuShuBoZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuZuFuMu.length == 1 ?'oneway':(data.twoFuZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuZuGu.length == 1 ?'oneway':(data.threeFuZuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZuGu.length == 1 ?'oneway':(data.fourFuTangZuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangBoFuMu.length == 1 ?'oneway':(data.fourFuTangBoFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangBoFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoBoFuMu.length == 1 ?'oneway':(data.threeFuShuBoBoFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoBoFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuShuBo.length == 1 ?'oneway':(data.twoFuShuBo.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuShuBo" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="one">
                        <div><b>一服</b></div>
                        <span :class="data.oneFuFuMu.length == 1 ?'oneway':(data.oneFuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.oneFuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuGuGu.length == 1 ?'oneway':(data.twoFuGuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuGuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoGu.length == 1 ?'oneway':(data.threeFuShuBoGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangGu.length == 1 ?'oneway':(data.fourFuTangGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="five">
                        <div><b>五服</b></div>
                        <span :class="data.fiveFuCongXiongDi.length == 1 ?'oneway':(data.fiveFuCongXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fiveFuCongXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangXiongDi.length == 1 ?'oneway':(data.fourFuTangXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoXiongDi.length == 1 ?'oneway':(data.threeFuShuBoXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuXiongDi.length == 1 ?'oneway':(data.twoFuXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="one">
                        <div><b>一服</b></div>
                        <span :class="data.oneFuZiJi.length == 1 ?'oneway':(data.oneFuZiJi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.oneFuZiJi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span></span
                    >
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuJieMei.length == 1 ?'oneway':(data.twoFuJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoJieMei.length == 1 ?'oneway':(data.threeFuShuBoJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangJieMei.length == 1 ?'oneway':(data.fourFuTangJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="five">
                        <div><b>五服</b></div>
                        <span :class="data.fiveFuCongJieMei.length == 1 ?'oneway':(data.fiveFuCongJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fiveFuCongJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZhi.length == 1 ?'oneway':(data.fourFuTangZhi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZhi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoZhiZi.length == 1 ?'oneway':(data.threeFuShuBoZhiZi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoZhiZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuZhiZi.length == 1 ?'oneway':(data.twoFuZhiZi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuZhiZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="one">
                        <div><b>一服</b></div>
                        <span :class="data.oneFuZiNv.length == 1 ?'oneway':(data.oneFuZiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.oneFuZiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuZhiNv.length == 1 ?'oneway':(data.twoFuZhiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoZhiNv.length == 1 ?'oneway':(data.threeFuShuBoZhiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZhiNv.length == 1 ?'oneway':(data.fourFuTangZhiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangSunZi.length == 1 ?'oneway':(data.fourFuTangSunZi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangSunZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoSun.length == 1 ?'oneway':(data.threeFuShuBoSun.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoSun" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuSunZiNv.length == 1 ?'oneway':(data.twoFuSunZiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuSunZiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoSunNv.length == 1 ?'oneway':(data.threeFuShuBoSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangSunNv.length == 1 ?'oneway':(data.fourFuTangSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuShuBoZengSun.length == 1 ?'oneway':(data.fourFuShuBoZengSun.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuShuBoZengSun" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuZengSunNv.length == 1 ?'oneway':(data.threeFuZengSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuZengSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuBoShuZengSunNv.length == 1 ?'oneway':(data.fourFuBoShuZengSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuBoShuZengSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuXuanSunNv  .length == 1 ?'oneway':(data.fourFuXuanSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuXuanSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                </ul>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import api from "@/request/api";
import Head from "@/components/header.vue";

export default {
    data() {
        return {
            activeName: "table",
            tableData: [],
            data: {},
            name: "",//孙洪津
            fathername: "",//孙献文
        };
    },
    mounted() {
    },
    methods: {
        search() {
            // /api/member/fivefubyname
            api.memberFivefubyname(
                this.$qs.stringify({
                    fid: localStorage.getItem("fid"),
                    name: this.name,
                    fathername: this.fathername
                })
            ).then((res) => {
                if (res.code == 0) {
                    this.data = res.data;
                    this.tableData = res.data;
                }
            });
        }
    },
    components: {
        Head
    }
};
</script>
<style lang="less">
.backColor1 {
    background-color: #fefc0b !important;
}
.backColor2 {
    background-color: #b3dee7 !important;
}
.backColor3 {
    background-color: #fabe8c !important;
}
.backColor4 {
    background-color: #91d04e !important;
}
.backColor5 {
    background-color: #fbc201 !important;
}
.fivefu {
    width: 100%;
    height: 100%;
    overflow: auto;
    .chartTop {
        height: 55px;
        line-height: 55px;
        padding-right: 20px;

        .active {
            color: #ff0000;
        }
        button {
            color: #000;
            margin: 0 5px;
        }
        .el-input {
            display: inline-block;
            width: 100px;
        }
    }

    > .fl {
        width: 210px;
        padding: 10px 20px;
        font-size: 14px;
        .el-input {
            margin: 10px 0;
            width: 90px;
            font-size: 16px;
        }
    }

    /deep/.el-table {
        border: 1px solid #000000 !important;
    }
    /deep/.el-table--border th.el-table__cell,
    /deep/.el-table__fixed-right-patch,
    /deep/td.el-table__cell,
    /deep/th.el-table__cell.is-leaf {
        border-bottom: 1px solid #000000 !important;
    }
    /deep/.el-table--border .el-table__cell {
        border-right: 1px solid #000 !important;
    }
    /deep/.el-table--border,
    /deep/.el-table--group {
        border: 1px solid #000000 !important;
    }
    .table,
    .mapdiv {
        width: calc(100% - 200px) ;
        height: calc(100% - 115px);
    }
    .table {
        overflow: auto;
    }

    .table tr td, .table tr th {
        border: 1px solid #908e8e;
        vertical-align:middle;
        padding: 0.5rem;
    }

    .mapdiv {
        height: calc(100% - 115px);
        overflow: auto;
        ul {
            text-align: center;
            width: 1100px;
            // width: 1300px;
            margin: 40px auto;
            .one,
            .two,
            .three,
            .four,
            .five {
                display: inline-block;
                height: 80px;
                width: 100px;
                margin: -1px;
                color: #000;
                overflow-x: auto;
            }
            .one {
                background: #fefc0b;
            }
            .two {
                background: #b3dee7;
            }
            .three {
                background: #fabe8c;
            }
            .four {
                background: #91d04e;
            }
            .five {
                background: #fbc201;
            }
            .one b,
            .two b,
            .three b,
            .four b,
            .five b {
                font-size:14px;
            }
            .one span,
            .two span,
            .three span,
            .four span,
            .five span {
                width:50px;
                display: block;
                float:left;
            }
          .one .spanmore,
          .two .spanmore,
          .three .spanmore,
          .four .spanmore,
          .five .spanmore {
            width:40px;
            display: block;
            float:left;
          }


            .one .oneway,
            .two .oneway,
            .three .oneway,
            .four .oneway,
            .five .oneway {
                width:100px;
                display: block;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/fivefu.vue